import Alert from "@pathwright/ui/src/components/alert/Alert"
import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import CardLink from "@pathwright/ui/src/components/card/CardLink"
import { Card as CardT } from "@pathwright/ui/src/components/card/types"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import PropTypes from "prop-types"
import {
  ContextualFeaturePermissionQueryVariables,
  useContextualFeaturePermissionQuery
} from "../../api/generated"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import FeatureBlockItem from "../block/FeatureBlockItem"
import { featurePermissionsQueryPropTypes } from "../propTypes"
import { getFeatureInfo } from "../utils"

const ManageFeature = ({
  card,
  ...variables
}: {
  card: CardT
} & ContextualFeaturePermissionQueryVariables) => {
  const { t } = useTranslate()
  const { school } = usePathwrightContext()

  const cfpQuery = useContextualFeaturePermissionQuery({
    variables
  })

  const feature = cfpQuery.data && cfpQuery.data.contextualFeaturePermission

  return (
    <Card card={card} emphasis="secondary">
      {cfpQuery.loading ? (
        <LoadingCircle center />
      ) : cfpQuery.error ? (
        <Alert error={cfpQuery.error} />
      ) : feature ? (
        <CardBlock paddingTop={false} paddingBottom={false}>
          <FeatureBlockItem feature={feature} />
          <CardLink
            icon="eye"
            label={t("Adjust visibility for all cohorts")}
            meta={t(
              "Configure who can see the {{ feature }} by default for all cohorts in {{ school }}",
              {
                feature: getFeatureInfo(feature.feature_key, t).title,
                school: school.name
              }
            )}
            to={`${window.location.pathname}settings/`}
          />
        </CardBlock>
      ) : null}
    </Card>
  )
}

ManageFeature.displayName = "ManageFeature"

ManageFeature.propTypes = {
  // provided by CardStack > CardStackCard
  card: PropTypes.object.isRequired,
  ...featurePermissionsQueryPropTypes
}

export default ManageFeature
